import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectActiveCandidate } from '../stores/store.js'
import { NameStateful } from './Name.jsx'

export function Zone({ values, onDrop, clickable, onClick }) {
  const [isDraggedHover, setIsDraggedOver] = useState(false)

  const onDragEnter = useCallback((event) => {
    event.preventDefault()
    setIsDraggedOver(true)
  })

  const onDragOver = useCallback((event) => {
    event.preventDefault()
  })

  const onDragLeave = useCallback(() => {
    setIsDraggedOver(false)
  })

  const _onDrop = useCallback((event) => {
    setIsDraggedOver(false)
    onDrop()
  }, [onDrop])

  const _onClick = useCallback(() => {
    if (clickable) {
      onClick()
    }
  }, [clickable, onClick])

  const classList = [
    "p-2",
    clickable || isDraggedHover ? "bg-blue-400" : "bg-blue-500"
  ]

  return <div className={ classList.join(" ") } style={{minHeight: "56px"}} onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDragOver={onDragOver} onDrop={_onDrop} onClick={_onClick}>
    <div className="hstack">
      {Array.from(values).sort().map((value, i) => {
        return <div key={i}>
          <NameStateful name={value} />
        </div>
      })}
    </div>
  </div>
}

export function ZoneStateful({ values, onDrop, onClick }) {
  const clickable = useSelector(selectActiveCandidate) !== null
  return <Zone values={values} onDrop={onDrop} clickable={clickable} onClick={onClick} />
}
